import { Navigate, Route, Routes } from "react-router";

import { useDetectDevice } from "./hooks/use-detect-device";
import { useGeneralConfiguration } from "./hooks/use-general-configuration";
import { Desktop } from "./pages/desktop/desktop";
import Error404 from "./pages/error-404/error-404";
import { Mobile } from "./pages/mobile/mobile";
import { SmartScheduling } from "./pages/smart-scheduling/smart-scheduling";
import { Device } from "./utils/enums";

function App() {
  // configurations like translation, timezone etc.
  useGeneralConfiguration();
  const device = useDetectDevice();
  const AppointmentPage = device === Device.Desktop ? <Desktop /> : <Mobile />;

  return (
    <Routes>
      <Route path="/404" element={<Error404 />} />
      <Route path="/:urlSlug" element={AppointmentPage} />
      <Route path="/embed/:urlSlug" element={AppointmentPage} />
      {/* rejection url */}
      <Route path="/rej/:urlSlug" element={AppointmentPage} />
      <Route
        path="/smart-scheduling/:userToken"
        element={<SmartScheduling />}
      />
      <Route path="*" element={<Navigate to="/404" />} />
    </Routes>
  );
}

export default App;
